import axios from "axios";
import { config } from "../config/envConfig";
import { getCookie } from "../utils/cookies";

const { cmeApiUrl } = config.environment;

export interface RieventSSOTokenRequest {
  skipProfileValidation: boolean;
  claims: { [key: string]: any };
}

export interface RieventSSOTokenResponse {
  userId: number;
  token: string | null;
  requiresReview: boolean;
}

export const getRieventSSOTokenService = async (request: any): Promise<any> => {
  const instance = axios.create({
    baseURL: cmeApiUrl,
    timeout: 30000,
  });
  const path = "/cmelaunch/token/rievent";
  const cookie = getCookie("accessToken");
  return instance
    .get(path, {
      params: {
        skipProfileValidation: request.cmeLaunchRequest.skipProfileValidation,
        claims: JSON.stringify(request.cmeLaunchRequest.claims),
      },
      headers: {
        Authorization: `${cookie}`,
        accept: "application/json",
      },
    })
    .then((response: any) => response)
    .catch((error: any) => {
      console.log(error);
      return error.response || { status: 500, data: {} };
    });
};
